/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type developmentVerificationStep_form$ref: FragmentReference;
declare export opaque type developmentVerificationStep_form$fragmentType: developmentVerificationStep_form$ref;
export type developmentVerificationStep_form = {|
  +id: string,
  +verified: boolean,
  +completed: boolean,
  +$refType: developmentVerificationStep_form$ref,
|};
export type developmentVerificationStep_form$data = developmentVerificationStep_form;
export type developmentVerificationStep_form$key = {
  +$data?: developmentVerificationStep_form$data,
  +$fragmentRefs: developmentVerificationStep_form$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "developmentVerificationStep_form",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    }
  ],
  "type": "DevelopmentRegistrationForm",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'bb40319b7398f53772814b05eaca2321';

export default node;
